import {
  Breadcrumbs,
  filtersToGraphQLFilters,
  IFlow,
  LOCAL_STORAGE_WORKBOARD_VIEW_MODE_KEY,
  makeDynamicWorkboardPageStore,
  PageViewModeEnum,
  PageViewModeToolbar,
  useSaveAndSetViewMode,
} from '@diana/core';
import { useIsFetching } from '@tanstack/react-query';
import { memo } from 'react';
import { useBreadcrumbsRoot } from '../../hooks/useBreadcrumbsRoot';
import { getWorkboardGraphQLWorksQueryKey } from './Support';

export const HeaderLeft = memo<{ flow: IFlow }>(
  (props) => {
    const { flow } = props;
    const breadcrumbRoot = useBreadcrumbsRoot('work');
    return <Breadcrumbs items={[breadcrumbRoot, { title: flow.displayName, hidden: false }]} />;
  },
  (prev, next) => prev.flow.id === next.flow.id,
);

export const HeaderRight = memo<{
  flow: IFlow;
  handleCsvButtonClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}>(
  (props) => {
    const { flow, handleCsvButtonClick } = props;

    const useWorkboardPageStore = makeDynamicWorkboardPageStore(flow.flowOriginId);
    const availableFilters = useWorkboardPageStore((store) => store.availableFilters);
    const filtersValues = useWorkboardPageStore((store) => store.filtersValues);
    const viewMode = useWorkboardPageStore((store) => store.viewMode);
    const setViewMode = useWorkboardPageStore((store) => store.setViewMode);
    const supportedViewModes = useWorkboardPageStore((store) => store.supportedViewModes);
    const isFetchingWorkboardWorks = useIsFetching({
      queryKey: getWorkboardGraphQLWorksQueryKey(
        flow.id,
        filtersToGraphQLFilters({
          filters: availableFilters,
          filtersValues,
        }),
      ),
    });

    const { saveAndSetViewMode } = useSaveAndSetViewMode({
      flowId: flow.id,
      storageKey: LOCAL_STORAGE_WORKBOARD_VIEW_MODE_KEY,
      setViewMode,
    });

    const onViewChange = (viewMode: PageViewModeEnum) => {
      saveAndSetViewMode(viewMode);
    };

    return (
      <PageViewModeToolbar
        viewMode={viewMode}
        onViewChange={onViewChange}
        supportedViewModes={supportedViewModes}
        isCsvButtonDisabled={isFetchingWorkboardWorks > 0}
        onCsvClick={
          [PageViewModeEnum.Table, PageViewModeEnum.TableExpanded].includes(viewMode)
            ? handleCsvButtonClick
            : undefined
        }
      />
    );
  },
  (prev, next) => prev.flow.id === next.flow.id,
);
